module.exports = __webpack_public_path__ + "img/sequence-miyashita-park.ecbffe3c.jpg";